import { useField } from 'formik';
import { FC, useCallback, useRef } from 'react';

import { Button, Text } from '@components';
import type { TextAreaInputProps } from '@types';

import { TextAreaInput } from '.';

export const ImportTextAreaInput: FC<TextAreaInputProps> = ({ name, uploadLabel, ...props }) => {
  const [, , helpers] = useField(name);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type === 'text/plain') {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = (e?.target?.result as string) ?? '';
        helpers.setValue(text);
      };
      reader.readAsText(file);
    }
  }, []);

  const handleButtonClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  return (
    <TextAreaInput
      name={name}
      adornment={
        <div className="flex flex-col items-center">
          <Button onClick={handleButtonClick} className="w-full rounded-lg">
            <Text $level={6} $customizeColor>
              {uploadLabel}
            </Text>
          </Button>
          <input ref={fileInputRef} type="file" accept=".txt" onChange={handleFileUpload} className="hidden" />
        </div>
      }
      {...props}
    />
  );
};
